export default {
  id: 146,
  title: 'Target #146 - Streaks',
  url: 'https://cssbattle.dev/play/146',
  colors: ['#998235', '#FCBE5C', '#0B2429'],
  solution:
    '<a><style>body{background:#998235}a{position:fixed;top:253;left:0;width:5in;height:25;background:#fcbe5c;transform:rotate(-45deg);box-shadow:0 25px #0b2429,0 50px #998235,0 75px #fcbe5c,0 100px #0b2429}</style>',
}
